var map = {
	"./aliyun.svg": "613e",
	"./apsara.svg": "56b6",
	"./aws.svg": "10ba",
	"./azure.svg": "3edf",
	"./baidu.svg": "be8e",
	"./bill_private.svg": "5bb8",
	"./bingocloud.svg": "d57c",
	"./ceph.svg": "e3d0",
	"./cephfs.svg": "971f",
	"./chinaunion.svg": "ffd6",
	"./cloudflare.svg": "0462",
	"./cloudpods.svg": "f267",
	"./cnware.svg": "5228",
	"./ctyun.svg": "f8c5",
	"./dstack.svg": "416a",
	"./ecloud.svg": "4516",
	"./gcp.svg": "42ca",
	"./google.svg": "09df",
	"./h3c.svg": "6d01",
	"./hcs.svg": "f124",
	"./hcso.svg": "e02f",
	"./hcsop.svg": "1267",
	"./huawei.svg": "76d6",
	"./incloudsphere.svg": "fda8",
	"./jdcloud.svg": "c08a",
	"./k8s.svg": "4cce",
	"./k8s2.svg": "e8a8",
	"./ksyun.svg": "344d",
	"./lb.svg": "1a35",
	"./nutanix.svg": "9601",
	"./oceanbase.svg": "e5f8",
	"./onecloud.svg": "d4fd",
	"./onestack.svg": "3286",
	"./openstack.svg": "72f0",
	"./oraclecloud.svg": "a0f2",
	"./pod.svg": "3d82",
	"./proxmox.svg": "d19d",
	"./qcloud.svg": "1703",
	"./qingcloud.svg": "34fc",
	"./remotefile.svg": "5544",
	"./s3.svg": "da7a",
	"./sangfor.svg": "e5ac",
	"./server.svg": "1246",
	"./tianyi.svg": "9d91",
	"./ucloud.svg": "9c7b",
	"./uis.svg": "e9a0",
	"./vmware.svg": "24df",
	"./volcengine.svg": "2ccf",
	"./xsky.svg": "c7ff",
	"./zettakit.svg": "34ae",
	"./zstack.svg": "40bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4116";